import { bootstrapApplication } from '@angular/platform-browser';
import { pdfDefaultOptions } from 'ngx-extended-pdf-viewer';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

// Absolute assets path so pdf.worker loads on nested CRM routes (not ./assets relative to URL path).
if (typeof window !== 'undefined') {
  pdfDefaultOptions.assetsFolder = `${window.location.origin}/assets`;
}

bootstrapApplication(AppComponent, appConfig)
    .catch((err) => console.error(err));

